import { useEffect, useState } from "react";


import OrganizationEditContainer from "./edit";
import OrganizationListContainer, { IRequestGetPagedOrg } from "./list";
import { ICodename, ILableOrganization, IPropModuleContainer, KeyModuleScreen } from "../../commons/interfaces";



const ModuleOrganization = (props: IPropModuleContainer<IRequestGetPagedOrg> & ILableOrganization & {
    title?: string,
    newDomain?: string,

    hidenStatus?: boolean,
    hidenActionUpdate?: boolean,
    hidenActionDelete?: boolean,
    hidenActionCreate?: boolean,
    hidenActionDeleteAllService?: boolean,

    showActionSpecifyOwner?: boolean,
    validateActionSpecifyOwner?: boolean,

    hidenActionUpdateStaff?: boolean,
    hidenActionDeleteStaff?: boolean,
    hidenActionCreateStaff?: boolean,
    hidenActionInvationStaff?: boolean,
    hidenActionDeleteStaffAllService?: boolean,

    hidenActionDeleteGroup?: boolean,
    hidenActionUpdateGroup?: boolean,
    hidenActionCreateGroup?: boolean,
    hidenInputSelectGroupParent?: boolean,
    requiredInputSelectGroupParent?: boolean,

    stepChildrens?: {
        label: string;
        children: React.ReactNode | JSX.Element;
    }[];

    modalCreateMember?: (props: {
        groupId?: string;
        organizationId: string;
        dataRoles?: ICodename[];
        dataGroups?: ICodename[];
        onCallBack?: () => void
    }) => JSX.Element;

    modalUpdateMember?: (props: {
        groupId?: string;
        organizationId: string;
        idDetailStaff?: string;
        dataRoles?: ICodename[];
        dataGroups?: ICodename[];

        visibleModal: boolean
        setVisibleModal: React.Dispatch<React.SetStateAction<boolean>>

        onCallBack?: () => void
    }) => JSX.Element;

    modalInvitationMember?: (props: {
        groupId?: string;
        organizationId: string;
        dataRoles?: ICodename[];
        dataGroups?: ICodename[];
        onCallBack?: () => void
    }) => JSX.Element;

    onUpdateListOrganization: (props: { data: ICodename[], isFetchUserInfo: boolean }) => Promise<any>;
}) => {
    const currentPath = window.location.pathname || "";

    const [idDetail, setIdDetail] = useState<string | undefined>(undefined);

    useEffect(() => { setIdDetail(props.idDetail); }, [props.idDetail]);

    const propsC = {
        mode: props.mode,
        idDetail: idDetail,

        title: props.title,
        newDomain: props.newDomain,
        lableStaff: props.lableStaff,
        lableGroup: props.lableGroup,
        lableOrganization: props.lableOrganization,

        hidenStatus: props.hidenStatus,
        hidenActionCreate: props.hidenActionCreate,
        hidenActionUpdate: props.hidenActionUpdate,
        showActionSpecifyOwner: props.showActionSpecifyOwner,
        validateActionSpecifyOwner: props.validateActionSpecifyOwner,

        hidenActionUpdateStaff: props.hidenActionUpdateStaff,
        hidenActionDeleteStaff: props.hidenActionDeleteStaff,
        hidenActionCreateStaff: props.hidenActionCreateStaff,
        hidenActionInvationStaff: props.hidenActionInvationStaff,
        hidenActionDeleteStaffAllService: props.hidenActionDeleteStaffAllService,

        hidenActionDeleteGroup: props.hidenActionDeleteGroup,
        hidenActionUpdateGroup: props.hidenActionUpdateGroup,
        hidenActionCreateGroup: props.hidenActionCreateGroup,
        hidenInputSelectGroupParent: props.hidenInputSelectGroupParent,
        requiredInputSelectGroupParent: props.requiredInputSelectGroupParent,

        stepChildrens: props.stepChildrens,

        modalCreateMember: props.modalCreateMember,
        modalUpdateMember: props.modalUpdateMember,
        modalInvitationMember: props.modalInvitationMember,

        onChangeMode: props.onChangeMode,
        onUpdateListOrganization: props.onUpdateListOrganization,
        onGoBack: () => {
            setIdDetail(undefined);
            props.onGoBack();
        },
    };

    const listContainers: { [key in KeyModuleScreen]?: JSX.Element; } = {
        "list": (
            <OrganizationListContainer
                title={props.title}
                lableStaff={props.lableStaff}
                lableGroup={props.lableGroup}
                lableOrganization={props.lableOrganization}

                hidenActionCreate={props.hidenActionCreate}
                hidenActionDelete={props.hidenActionDelete}
                hidenActionUpdate={props.hidenActionUpdate}
                hidenActionDeleteAllService={props.hidenActionDeleteAllService}

                onGetPaged={props.onGetPaged}
                requestGetPaged={props.requestGetPaged}
                onUpdateListOrganization={props.onUpdateListOrganization}
                onNavigate={async (data) => {
                    setIdDetail(data.id);
                    await props.onNavigate(data);
                }}
            />
        ),
        "detail": (<OrganizationEditContainer  {...propsC} />),
        "update": (<OrganizationEditContainer  {...propsC} />),
        "create": (<OrganizationEditContainer  {...propsC} />),
    };

    const renderContainerView = () => {
        const itemFind = Object.keys(props.keyModuleContainer).find((key) => ((props.keyModuleContainer as any)[key]?.pathName === currentPath));
        return (listContainers as any)[itemFind];
    };

    return <>{renderContainerView()}</>;
};

export default ModuleOrganization;
